import axios from '@/plugins/axios';
import Vue from 'vue';
import VueToastr from '../../plugins/VueToastr';

Vue.use(VueToastr, {
    timeout: 3000
});

const toastrInstance = new Vue();

export const apiRedirectToLawlexModule = async (type) => {
    const config = {
        lawlexau: {
            windowKey: 'lawlexurl',
            endpoint: '/management/ipd/redirectToLawlex',
            moduleLabel: 'NineDots - Lawlex',
        },
        lawlexeu: {
            windowKey: 'eurlexurl',
            endpoint: '/management/ipd/redirectToEurlex',
            moduleLabel: 'NineDots - Eurlex',
        },
        lawlexus: {
            windowKey: 'lawlexusurl',
            endpoint: '/management/ipd/redirectToLawlexUS',
            moduleLabel: 'NineDots - LawlexUS',
        },
        comply: {
            windowKey: 'complyurl',
            endpoint: '/management/ipd/redirectToComply',
            moduleLabel: 'NineDots - Comply',
        },
    };

    const c = config[type];
    if (!c) {
        toastrInstance.$toastr.e('Invalid redirect type');
        return;
    }

    try {
        let formData = new FormData();

        const raw = window[c.windowKey];
        const decoded = raw
            ? JSON.parse(Buffer.from(raw, 'base64').toString())
            : null;

        const landingPath = type === 'comply' ? '/SSO' : '/Dashboard';
        formData.append('url', `${decoded?.url || ''}${landingPath}`);
        formData.append('module', c.moduleLabel);

        const response = await axios.post({
            endpoint: c.endpoint,
            params: formData,
            options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } },
        });

        if (response?.data?.success) {
            window.location.href = response.data.redirect;
            return;
        }

        throw new Error(response?.data?.error || 'Unknown error occurred');
    } catch (error) {
        console.error('API Error:', error);

        const errorMessage =
            (error.response && error.response.data && error.response.data.error) ||
            error.message ||
            'An error occurred';

        toastrInstance.$toastr.e(errorMessage);
    }
};

export const apiGetLawlexAddonStatus = async () => {
    return axios.get({ endpoint: '/management/ipd/getLawlexStatus', params: {}, options: { headers: { 'X-Requested-With': 'XMLHttpRequest' } } })
        .then((response) => {
            return response.data.status;
        }).catch(() => {
            console.log("Get lawlex addon status failed!");
        });
}

export const apiAddToIpdLog = async (moduleName, linkClicked) => {
    try {
        let options = {};
        let params = {};
        options = {headers: {'Content-Type': 'application/x-www-form-urlencoded'}};
        params = new URLSearchParams();
        params.append('moduleName' , moduleName);
        params.append('linkClicked' , linkClicked);
        const response = await axios.post({
            endpoint: '/management/ipd/addToIpdLog',
            params: params,
            options: options
        });
        if (response.data) {
            return response.data;
        }
    } catch (e) {
        console.log('There has been a problem with your fetch operation:'+ e.message);
    }
}
